import curbsidePickupCheckin from 'services/api/notifications/curbsidePickupCheckin';
import smsSubscribe from 'services/api/notifications/smsSubscribe';

export default {
    curbsidePickupCheckin,
    smsSubscribe
};
